var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcnBlur = function SvgIcnBlur(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.572 4h1.904v5.614l.678.646h4.084V11.887h-5.202l-1.292-1.458-.172-.16V4Z",
    fill: "#595959"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.19 4h5.87l.917 1.012h.003l.088.1.36.397h-.015l.015.018v1.59l-.745.72.745.856v1.576l-.004.005h.004l-1.447 1.614H4.19V4Zm1.808 1.527h3.26l.359.405v.837l-.358.347H5.998V5.527Zm0 4.742h3.26l.359-.356v-.801l-.358-.419H5.998v1.576Z",
    fill: "#595959"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 13.101h1.905v5.615l.695.767h2.229l.694-.819v-5.563h1.905v6.382L10.203 21h-4.94L4 19.483v-6.382Z",
    fill: "#595959"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.572 13.101v7.887h1.904V17.89h3.295l.381.348v2.75H20V17.89l-.79-.72.79-.855v-1.572l-.023-.021h.011l-1.438-1.62h-5.979Zm5.573 2.795v-.166h.007v-.641l-.38-.346h-3.296v1.572h3.288l.38-.419Z",
    fill: "#595959"
  })));
};
export default SvgIcnBlur;